<template>
  <b-container>
    <b-row class="justify-content-center">
      <b-col cols="12" md="10" lg="8">
        <h2 class="mb-3">{{ $t("titre_contact")}}</h2>
        <b-card>
          <ul class="list-unstyled mb-0 contact-list">
            <li class="mb-2">
              <p class="mb-1">{{ $t('contact_questions') }} :
                <strong>clem [ {{ $t('at') }} ] clementbesnier ({{ $t('point') }}) fr</strong>
              </p>
            </li>

            <li class="mb-2">
              <p class="mb-1">
                <a href="https://github.com/clemsciences" target="_blank" rel="noopener">{{ $t('contact_github') }}</a>
              </p>
            </li>

            <li class="mb-2">
              <p class="mb-1">
                <a href="https://connect.ed-diamond.com/auteur/besnier-clement" target="_blank" rel="noopener">{{ $t("contact_articles_linux") }}</a>
              </p>
              <ul class="mb-1">
                <li>
                  <a href="https://connect.ed-diamond.com/GNU-Linux-Magazine/GLMF-212/Programmation-dynamique-et-alignement-de-sequences" target="_blank" rel="noopener">{{ $t('contact_article_programmation_dynamique') }}</a>
                </li>
              </ul>
            </li>

            <li class="mb-2">
              <p class="mb-1"><router-link to="/contact/cv">CV</router-link></p>
            </li>

            <li class="mb-3">
              <p class="mb-1">
                {{ $t('contact_membre_ca') }}
                <a href="https://societearcheotouraine.eu/" target="_blank" rel="noopener">{{ $t('contact_societe_archeologique_de_touraine') }}</a>
                {{ $t('contact_membre_suite')}}.
              </p>
              <a href="https://societearcheotouraine.eu/" target="_blank" rel="noopener">
                <img class="arrondie img-fluid" src="images/logo-sat-societe-archeologique-touraine-37-bandeaubloc1.jpg" alt="Logo de la SAT" style="max-height: 120px">
              </a>
              <p class="mt-2">
                {{ $t('contact_site_sat') }}
                <a href="https://bht.societearcheotouraine.fr" target="_blank" rel="noopener">{{ $t('contact_accueil_app_web') }}</a>.
              </p>
            </li>

            <li class="mb-2">
              <p class="mb-1">
                {{ $t('contact_membre') }}
                <a href="http://www.astrotouraine.fr/" target="_blank" rel="noopener"> {{ $t('contact_societe_astronomique_de_touraine') }}</a>.
              </p>
              <a href="https://www.astrotouraine.fr/" target="_blank" rel="noopener">
                <img class="arrondie img-fluid" src="images/SAstronomieT.png" alt="Logo de la SAT" style="max-height: 120px">
              </a>
            </li>
          </ul>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
name: "Contact",
  mounted() {
    // Optional: load Twitter widgets if timeline is re-enabled later
    // let twitterScript = document.createElement('script')
    // twitterScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
    // twitterScript.setAttribute('charSet', 'utf-8')
    // document.head.appendChild(twitterScript);
  }
}
</script>

<style scoped>
.contact-list li p {
  line-height: 1.5;
}
</style>